export default {
  choose_preferred_wallet: "Elige tu billetera preferida",
  connect_mobile_wallet: "Conectar a billetera móvil",
  scan_qrcode_with_wallet: "Escanea el código QR con una billetera compatible con WalletConnect",
  return_to_mobile_options: "Regresar a las opciones de billetera móvil",
  view_qrcode_option: "Ver código QR",
  connect: "Conectar",
};
